<template>
    <div>
        <v-card >
            <v-card-title class="blue_corp white--text">
                <v-row>
                    <v-col cols="6" md="6">NOTA CRÉDITO</v-col>
                    <v-col cols="6" md="6">
                        <v-row class="mt-0 mr-2" justify="end">
                            <span class="text-caption"><v-chip color="white"><strong class="text-body-2">{{txtSucursal}}</strong></v-chip></span>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="3" class="mt-n2">
                                <v-radio-group v-model="docDTE" row>
                                    <v-radio @click="newVenta()" label="Factura" color="success" value="5"></v-radio>
                                    <v-radio @click="newVenta()" label="Boleta" color="success" value="22"></v-radio>
                                </v-radio-group>
                            </v-col>                            
                            <v-col cols="8" md="2" class="d-flex">
                                <v-text-field class='text-caption' v-model="orden" label="Numero" :disabled="disabledOrden" :filled="filledOrden" outlined dense required></v-text-field>
                                <v-btn @click="verDTE(orden)" class="mt-1 ml-2" small color="teal" dark rounded><v-icon small>search</v-icon></v-btn>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-text-field class='text-caption' v-model="rut" label="Rut Cliente" dense outlined disabled filled></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field class='text-caption' v-model="razon" label="Nombre" dense outlined disabled filled></v-text-field>
                            </v-col>
                            <v-col cols="4" md="1">
                                <v-btn v-if="ntipoDte==22" class="mt-1" @click="dialog=true" small color="teal" dark rounded><v-icon small>streetview</v-icon></v-btn>
                                <v-btn v-else class="mt-1" small color="grey" dark rounded><v-icon small>streetview</v-icon></v-btn>
                            </v-col>
                            <!-- <v-col cols="12" md="2">
                                <v-text-field class='text-caption' v-model="ndev" label="Orden" dense outlined filled disabled></v-text-field>
                            </v-col> -->
                        </v-row>
                        <v-divider></v-divider>
                        <v-row>
                            <v-col cols="12" md="9">
                                <v-data-table :headers="headers" :items="items" :page.sync="page" :items-per-page="itemsPerPage" hide-default-footer class="elevation-1 text-size col-color" @page-count="pageCount = $event">
                                    <template v-slot:item.tcantidad="{ item }">
                                        <v-edit-dialog v-if="docDTE!='2'" @save="save(item)" @cancel="cancel()" @close="close()" @open="open()">
                                            <v-icon small class="ml-1 blue--text">edit</v-icon>
                                            <span class="ml-1">{{item.cantidad}}</span>
                                            <v-icon class="ml-1 red--text" @click="menos(item)">arrow_drop_down</v-icon>
                                            <template v-slot:input>
                                                <div class="mt-4 text-h6">Cantidad</div>
                                                <v-text-field v-if="item.medida!='UN'" @keypress="onlyDecimal" v-model="editCantidad" single-line></v-text-field>
                                                <v-text-field v-else @keypress="onlyNumber" v-model="editCantidad" single-line></v-text-field>
                                            </template>
                                        </v-edit-dialog>
                                        <span v-else small>{{ item.tcantidad }}</span>
                                    </template>
                                    <template v-slot:item.accion="{ item }">
                                        <v-icon v-if="docDTE!='2'" small class="red--text" @click="deleteItem(item)">delete</v-icon>
                                        <v-icon v-else small class="grey--text">delete</v-icon>
                                    </template>
                                </v-data-table>
                                <v-pagination v-model="page" :length="pageCount"></v-pagination>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-alert class='text-caption' dense text border="left" color="grey">
                                    <div class="float-left">
                                        Neto
                                    </div>
                                    <div class="float-right">
                                        ${{new Intl.NumberFormat("de-DE").format(parseFloat(neto))}}
                                    </div>                                             
                                </v-alert>
                                <v-alert class='mt-n2 text-caption' dense text border="left" color="grey">
                                    <div class="float-left">
                                        Iva ({{impuesto}}%)
                                    </div>
                                    <div class="float-right">
                                        ${{new Intl.NumberFormat("de-DE").format(parseFloat(iva))}}
                                    </div>                                             
                                </v-alert>
                                <v-alert style="height:40px;" class='mt-n2 text-body-2' dense text border="left" color="red">
                                    <div class="mt-1 float-left">
                                        Total
                                    </div>
                                    <div class="mt-1 float-right">
                                        ${{new Intl.NumberFormat("de-DE").format(parseFloat(total))}}
                                    </div>                                             
                                </v-alert>
                                <!-- <v-alert class='text-caption' dense text border="left" color="grey">Neto ($):{{neto.toLocaleString()}}</v-alert> 
                                <v-alert class='text-caption' dense text border="left" color="grey">Iva ({{impuesto}}%): {{iva}}</v-alert>
                                <v-alert class='text-caption' dense text border="left" color="red">Total ($): {{total.toLocaleString()}}</v-alert> -->
                            </v-col>
                            <v-col cols="12" md="1">
                                <v-text-field class='text-caption' v-model="totaldev" label="NC" disabled filled dense></v-text-field>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-select class='text-caption' v-model="dte" :items="itemDTE" label="Selecciona DTE" item-text="doc" item-value="id"></v-select>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-select class='ml-2 text-caption' v-model="pago" :items="itemPAGO" label="Forma Pago" item-text="forma" item-value="id"></v-select>
                            </v-col>
                              <v-col cols="12" md="3">
                                <v-text-field class='text-caption' v-model="envio" label="Envio Digital" dense filled></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <div class="mt-5 text-right">
                                    <v-btn @click="newVenta()" small color="teal" dark rounded><v-icon small>add_circle</v-icon><span class='text-btn'>Nuevo</span></v-btn>
                                    <!-- <v-btn v-if="btnGrabar===true" @click="outDTE(dte,pago)" class="ml-2" small color="teal" dark rounded><v-icon small>save</v-icon><span class='text-btn'>Grabar</span></v-btn> -->
                                    <v-btn v-if="btnGrabar===true" @click="enviarDTE(dte,pago)" class="ml-5" small color="teal" dark rounded><v-icon small>save</v-icon><span class='text-btn'>Enviar DTE</span></v-btn>
                                    <v-btn v-else class="ml-5" small color="grey" dark rounded><v-icon small>save</v-icon><span class='text-btn'>Enviar DTE</span></v-btn>
                                    <v-btn class="ml-10" v-if="sigla=='INV'" icon>
                                        <a v-if="btnPrt===true" target="_blank" :href="html"><v-icon color="success" large>print</v-icon></a>
                                        <a v-else href="javascript:void(0)"><v-icon class="red--text" large>print</v-icon></a> 
                                    </v-btn>    
                                    <v-btn class="ml-10" v-if="sigla=='NDV'" icon>
                                        <v-icon v-if="btnPrt===true" @click="imprimirPDF()" color="teal" large>print</v-icon>
                                        <v-icon v-else color="grey" large>print</v-icon>
                                    </v-btn>
                                    <!-- <a  class="ml-2" v-if="descargaCSV===false" href="javascript:void(0)" @click="fileCSV()"><img valign="middle" src="@/assets/csv.png" width="16px" height="20px"/></a>
                                    <a  class="ml-2" v-else :href="rutaCSV"><v-icon color="teal">cloud_download</v-icon></a> -->
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
            </v-card-text>
            <v-card-actions style="margin-top:-35px">
            </v-card-actions>
        </v-card>
        <!-- Dialogo Cliente Boleta -->
        <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="700" persistent>
            <form>
            <v-card>
            <v-toolbar color="primary" dark>Cliente Devolución Boleta</v-toolbar>
            <v-card-text class="mt-5">
                <v-row>                    
                     <v-col cols="12" md="4">
                        <v-text-field class='text-caption' v-model="dev_rut" label="Rut" outlined dense></v-text-field>
                     </v-col>    
                     <v-col cols="12" md="4">
                        <v-text-field class='text-caption' v-model="dev_nombre" label="Nombre" outlined dense></v-text-field>
                     </v-col>    
                     <v-col cols="12" md="4">
                        <v-text-field class='text-caption' v-model="dev_apellido" label="Apellido" outlined dense></v-text-field>
                     </v-col>    
                     <v-col cols="12" md="6">
                        <v-text-field class='text-caption' v-model="dev_direccion" label="Direccion" outlined dense></v-text-field>
                     </v-col>    
                     <v-col cols="12" md="3">
                        <v-text-field class='text-caption' v-model="dev_comuna" label="Comuna" outlined dense></v-text-field>
                     </v-col>    
                     <v-col cols="12" md="3">
                        <v-text-field class='text-caption' v-model="dev_ciudad" label="Ciudad" outlined dense></v-text-field>
                     </v-col>    
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="salirDialog()" color="indigo">Salir</v-btn>
                <v-spacer></v-spacer>
                <v-btn text @click="closeDialog()" color="indigo">Enviar</v-btn>
            </v-card-actions>
          </v-card>
          </form>
        </v-dialog>
        <snack :Msg="Msg" :color="color" :msgbox="msgbox"/>
        <dialogo :loading="loading"  />        
    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 9pt !important;
    height: 25px !important;
    /*background-color: lightyellow;*/ 
}
.col-color >>> th {
    background-color: lightgrey;
}
</style>
<script>
import snack from '@/components/snack.vue';
import dialogo from '@/components/dialogo.vue';
import { jsPDF } from "jspdf";
import axios from 'axios';
export default {
    name:'Devolucion', 
    components:{dialogo, snack},
    props: ['usu','contrato'],   
    data(){
        return{
            //contrato:'123',
            loading:false,
            msgbox:false,
            color:'',
            Msg:'',
            disabledOrden:false,
            filledOrden:false,
            disabledDatos:true,
            btnGrabar:false,
            btnPrt:false,
            html:'',
            orden:'',
            ndev:'0',
            totaldev:'0',
            entidad:'',
            rut:'',
            razon:'',
            direccion:'',
            comuna:'',
            ciudad:'',
            giro:'',
            email:'',
            fecha:'',
            hoy:'',
            neto:0,
            impuesto:'',
            iva:0,
            total:0,
            dte:'',
            pago:'',
            page: 1,
            pageCount: 0,
            itemsPerPage: 4,
            headers: [
                { text: 'Codigo', align: 'start', sortable: true, value: 'codigo', width:'10%' },
                { text: 'Producto', align: 'start', sortable: false, value: 'producto', width:'40%' },
                { text: 'Precio', align: 'center', sortable: false, value: 'precio', width:'10%' },
                { text: 'Cantidad', align: 'center', sortable: false, value: 'tcantidad', width:'20%' },
                { text: 'Medida', align: 'center', sortable: false, value: 'medida', width:'10%' },
                // { text: 'Bodega', align: 'center', sortable: false, value: 'bodega' },
                { text: '', align: 'center', sortable: false, value: 'accion', width:'10%' }
            ],
            items: [],
            itemDTE:[
                {id:'2',doc:'Nota Credito'},
            ],
            itemPAGO:[],
            // itemPAGO:[
            //     {id:'1',forma:'EFECTIVO'},
            //     {id:'8',forma:'TRANSFERENCIA'},
            //     {id:'4',forma:'CREDITO'}
            // ],
            OutID:0,  
            descargaCSV:false,
            rutaCSV:'',
            envio:'',
            nSucursal:0,
            txtSucursal:'',
            ntipoDte:0,
            dialog:false,
            dev_rut:'',
            dev_nombre:'',
            dev_apellido:'',
            dev_direccion:'',
            dev_comuna:'',
            dev_ciudad:'',
            docDTE:'5',
            idLocal:0,
            editCantidad:'',
            office:0,

            nClicks:0,
            sigla:'',

        }
    },
    async mounted(){
        this.sigla=this.contrato.substring(0,3).toUpperCase();
        console.log('sigla',this.sigla)
        await this.newVenta();
        // this.buscarSucursal()
        await this.buscaLocal();
    },
    methods:{
        async cargaPagos(xRut){
            try {
                var auth='NO';
                const res = await axios.get(process.env.VUE_APP_URL + '/api/inv/clientes/'+this.contrato+'/'+ xRut);
                const dat=res.data;
                if (dat[0].existe=='si'){ auth=dat[0].Credito };            
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/DTE/forma/pago/'+this.contrato);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    this.itemPAGO=[];
                    datos.forEach(element => {
                        if(element.CodigoBsale=='4'){
                            if(auth=='SI'){
                                this.itemPAGO.push({
                                    'id':element.CodigoBsale,
                                    'forma':element.Descripcion
                                })
                            }
                        } else {
                            if(element.CodigoBsale=='1' || element.CodigoBsale=='8'){
                                this.itemPAGO.push({
                                    'id':element.CodigoBsale,
                                    'forma':element.Descripcion
                                })
                            }
                        }
                    });
                }                
            } catch (error) {
                console.log(error)
            }
        },
        async buscaLocal(){
            try {
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/usuarios/'+this.contrato+'/'+this.usu);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    this.idLocal=datos[0].Bodega;
                    this.nSucursal=this.idLocal;
                    this.office = datos[0].Sucursal;
                    const sucu=await this.buscarSucursal_v2();
                    if(sucu!=''){
                        this.txtSucursal=sucu;
                    } else {
                        this.txtSucursal=this.nSucursal;
                    }
                }
            } catch (error) {
                console.log(error)
            }
        },
        async buscarSucursal_v2(){
            let res = '';
            try {
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/bodegas/'+this.contrato);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    datos.forEach(element => {
                        if(element.ID==this.nSucursal){
                            res = element.Nombre
                        };
                    });
                }                
            } catch (error) {
                console.log(error)
            };
            return res
        },
        salirDialog(){
            //this.rut='';
            this.dev_rut='';
            this.dev_nombre='';
            this.dev_apellido='';
            this.dev_direccion='';
            this.dev_comuna='';
            this.dev_ciudad='';
            this.dialog=false;
        },
        closeDialog(){            
            if(this.dev_rut.trim()!='' &&
                this.dev_nombre.trim()!='' &&
                this.dev_apellido.trim()!='' &&
                this.dev_direccion.trim()!='' &&
                this.dev_comuna.trim()!='' &&
                this.dev_ciudad.trim()!=''){
                let ruts=this.validaRut(this.dev_rut);
                if (ruts){
                    this.rut=this.dev_rut;
                    this.razon=this.dev_nombre+' '+ this.dev_apellido;
                    this.dialog=false;                    
                } else {
                    this.Msg='Rut no Valido'
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                }
            } else {
                this.Msg='Datos Obligatorios'
                this.msgbox=true;
                this.color='red';
                this.showSnack();
            }
        },
        validaRut(rutCompleto){
            if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test( rutCompleto ))
			    return false;
		    var tmp 	= rutCompleto.split('-');
		    var digv	= tmp[1]; 
		    var ruti 	= tmp[0];
		    if ( digv == 'K' ) digv = 'k' ;
		    return (this.dv(ruti) == digv );
        },
        dv(T){
            var M=0,S=1;
    		for(;T;T=Math.floor(T/10))
	    		S=(S+T%10*(9-M++%6))%11;
		    return S?S-1:'k';
        },
        // async buscarSucursal(){
        //     const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/usuarios/'+this.contrato+'/'+this.usu);
        //     const datos=response.data;
        //     if (datos[0].existe=='si'){
        //         if (datos[0].Sucursal!=0){
        //             this.nSucursal=datos[0].Sucursal;
        //             const response1 = await axios.get(process.env.VUE_APP_URL + '/api/inv/sucursales/'+this.contrato);
        //             const datos1=response1.data;
        //             if (datos1[0].existe=='si'){
        //                 datos1.forEach(element => {
        //                     if(element.ID==this.nSucursal){
        //                         this.txtSucursal=element.Nombre                            
        //                     }
        //                 });
        //             } else {  
        //                 this.txtSucursal='Sin Sucursal';
        //                 this.nSucursal=0;
        //             }
        //         } else {
        //             this.txtSucursal='Sin Sucursal';
        //             this.nSucursal=0;
        //         }
        //     } else { 
        //         this.txtSucursal='Sin Sucursal';
        //         this.nSucursal=0;
        //     }
        // },
        async fileCSV(){
            if (this.btnPrt===true){
                this.loading=true;
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/fileCsv/dev/'+this.contrato+'/'+this.OutID+'/'+this.entidad);
                const datos=response.data;
                //console.log(datos);
                if (datos=='si'){
                    this.descargaCSV=true;
                    this.rutaCSV=process.env.VUE_APP_URL + '/buzon/'+this.contrato+'/'+this.OutID+'.csv';
                }
                this.loading=false;
            }
        },
        showSnack(){
            setTimeout(()=>{this.msgbox=false},3000)
        },
        clsInput(){
            this.entidad='';
            this.ndev='0';
            this.totaldev='0';
            this.rut='';
            this.razon='';
            this.direccion='';
            this.comuna='';
            this.ciudad='';
            this.giro='';
            this.email='';
            this.fecha='';
            this.hoy='';
            this.neto=0;
            this.iva=0;
            this.total=0;
            this.impuesto='';
            this.dte='';
            this.pago='';
            this.items=[];
            this.btnPrt=false;
            this.html='';
            this.OutID=0;
            this.descargaCSV=false;
            this.rutaCSV='';  
            this.envio='';
            this.disabledDatos=true;
            this.ntipoDte=0;
            this.dev_rut='';
            this.dev_nombre='';
            this.dev_apellido='';
            this.dev_direccion='';
            this.dev_comuna='';
            this.dev_ciudad='';
            this.editCantidad='';
            this.nClicks=0;
        },
        async newVenta(){
            this.orden='';
            this.disabledOrden=false;
            this.filledOrden=false;
            this.btnGrabar=false;
            this.clsInput();
            if(parseInt(this.docDTE)==22){
                this.cargaPagos('1-9')
            }
            if(parseInt(this.docDTE)==5 || parseInt(this.docDTE)==22){
                this.itemDTE=[];
                this.itemDTE.push({ id:'2',doc:'Nota Credito' });
            }
            if(parseInt(this.docDTE)==2){
                this.itemDTE=[];
                this.itemDTE.push({ id:'17',doc:'Nota Debito' });
            }
        },
        async verDTE(nOrden){
            if (this.orden!=''){
                this.clsInput();
                this.loading=true;
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/DTE/dev/'+this.contrato+'/'+nOrden+'/'+this.docDTE);
                const datos=response.data;
                console.log('orden', datos);
                if (datos[0].existe=='si'){
                    this.disabledDatos=false;  
                    this.disabledOrden=true;
                    this.filledOrden=true;
                    this.btnGrabar=true;
                    this.ndev = datos[0].Orden;
                    this.totaldev = datos[0].Devolucion;
                    this.entidad=datos[0].Entidad;
                    this.rut=datos[0].Rut;
                    this.razon=datos[0].Nombre;
                    this.direccion=datos[0].Direccion;
                    this.comuna=datos[0].Comuna;
                    this.ciudad=datos[0].Ciudad;
                    this.giro=datos[0].Observacion;
                    this.email=datos[0].Email;
                    this.fecha=datos[0].Hoy;
                    this.hoy=datos[0].Hoy;
                    this.impuesto=datos[0].Iva;
                    this.cargaPagos(this.rut);
                    this.ntipoDte=parseFloat(this.docDTE); //datos[0].TipoDte;
                    this.items=[];
                    let nNeto=0;
                    let nTotal=0;
                    //obtener las NC y sumarlas para mostrar el total de devolucion
                    const array_devoluciones = await axios.get(process.env.VUE_APP_URL + '/api/inv/DTE/suma_dev/' + this.contrato + '/' + this.ndev);
                    const data_devolutions = array_devoluciones.data;
                    console.log('array_devoluciones', data_devolutions);
                    for (let index = 0; index < datos.length; index++) {
                        const element = datos[index];
                        let cantidad_dev = 0;
                        if(data_devolutions.length!=0){
                            //obtener nuevas cantidades
                            const devolutions = data_devolutions.filter(res => res.Sku == element.Sku);
                            if(devolutions.length!=0){
                                cantidad_dev = devolutions[0].Cantidad;
                            };
                        };
                        const cantidad_restante = parseFloat(cantidad_dev) + parseFloat(element.Cantidad);
                        //calcular precio unitario
                        let imp=1+(this.impuesto/100);
                        let unidad=element.Precio/imp;
                        const tMedida=await this.searchMedida(element.Sku);
                        this.items.push({
                            'codigo':element.Sku,
                            'producto':element.Producto,
                            'precio':new Intl.NumberFormat("de-DE").format(parseFloat(element.Precio)),
                            'unidad':unidad,
                            'tcantidad':new Intl.NumberFormat("de-DE").format(parseFloat(cantidad_restante).toFixed(3)),
                            'cantidad': cantidad_restante,
                            'medida':tMedida,
                            'bodega':element.Bodega,
                            'precioitem':element.Precio,
                            "cantidaditem": cantidad_restante
                        });
                        nNeto=nNeto+(unidad*parseFloat(cantidad_restante));
                        //nTotal=nTotal+parseFloat(element.Total)       
                    };
                    let nIva=(nNeto*parseFloat(datos[0].Iva))/100;
                    this.neto=parseFloat(nNeto).toFixed(2);
                    this.iva=parseFloat(nIva).toFixed(2);                 
                    //this.total=nTotal;
                    this.total=parseFloat(this.neto)+parseFloat(this.iva);
                    if (this.ntipoDte==22){
                        if (this.sigla=='INV') {
                          this.rut='';
                          this.dev_rut='';
                        }
                    }
                } else {
                    this.Msg='Orden no Existe o con DTE'
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                }
                this.loading=false;
            }
        },
        async searchMedida(mSku){
            try {
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/unidad/medida/'+ this.contrato +'/'+ mSku);
                const datos=response.data;
                if (datos[0].existe=='si'){ 
                    return datos[0].Medida;
                } else { return 'Sin Medida' }
            } catch (error) {
                return 'Sin Medida'
            }
        },
        async reCalcular(newTotal){
                let imp=1+(this.impuesto/100);
                let varNeto=newTotal/imp;
                let varIva=(varNeto*this.impuesto)/100;
                this.neto=parseFloat(varNeto).toFixed(2);
                this.iva=parseFloat(varIva).toFixed(2);
                this.total=newTotal;
        },
        async deleteItem(array){
            // this.items = this.items.filter(function(dat) {
            //     return dat.codigo !== array.codigo; 
            // });
            let varTotal=parseFloat(this.total)-(parseFloat(array.precioitem)*parseFloat(array.cantidad));
            array.cantidad='0';
            array.tcantidad='0';
            await this.reCalcular(varTotal);
        },
        async menos(array){
            if (array.cantidad>1){
                array.cantidad=parseFloat(array.cantidad)-1
                array.tcantidad=new Intl.NumberFormat("de-DE").format(parseFloat(array.cantidad).toFixed(3));
                let varTotal=parseFloat(this.total)-parseFloat(array.precioitem);
                await this.reCalcular(varTotal);
            } else {
                if (array.cantidad>0){
                    // array.cantidad=parseFloat(array.cantidad)-1
                    // array.tcantidad=new Intl.NumberFormat("de-DE").format(parseFloat(array.cantidad).toFixed(3));
                    let varTotal=parseFloat(this.total)-(parseFloat(array.precioitem)*parseFloat(array.cantidad));
                    array.cantidad='0';
                    array.tcantidad='0';
                    await this.reCalcular(varTotal);
                }
            }
        },
        // async outDTE(selectDTE,selectPago){
        //     if (parseFloat(this.total)!=0){
        //         if (selectDTE!=0 && selectPago!=0){
        //             this.loading=true;
        //              this.btnGrabar=false;
        //             //obtener ID nuevo del dte
        //             const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/DTE/id/new/'+this.contrato);
        //             const res = response.data;
        //             if (res[0].existe=='si'){ 
        //                 this.OutID=parseFloat(res[0].ID)+1; 
        //                 this.html=process.env.VUE_APP_URL + '/api/inv/prt/dev/'+this.contrato+'/'+this.OutID+'/'+this.entidad;            
        //                 const paramsDTE={
        //                     'contrato':this.contrato,
        //                     'numero':this.OutID,
        //                     'tipoDte':selectDTE,
        //                     'tipoPago':selectPago,
        //                     'neto':this.neto,
        //                     'iva':this.iva,
        //                     'total':this.total,
        //                     'fecha':this.hoy,
        //                     'orden':this.ndev,
        //                     'rutaPDF':this.html,
        //                     'rutaXML':this.html,
        //                     'usuario':this.usu
        //                 };     
        //                 await this.saveDTE(paramsDTE); 
        //             } else {  
        //                 this.OutID=0 
        //                 this.Msg='Sin ID Devolución'
        //                 this.msgbox=true;
        //                 this.color='red';
        //                 this.showSnack();
        //             };
        //         } else {
        //             this.Msg='Seleccione DTE y Pago'
        //             this.msgbox=true;
        //             this.color='red';
        //             this.showSnack();
        //         }
        //     } else {
        //     }
        //     this.loading=false;
        // },
        async enviarDTE(selectDTE,selectPago){
            this.loading=true;
            this.nClicks ++;
            if(parseInt(this.nClicks)==1){
                // validar tipo de sistema
                if (this.sigla=='INV') {
                    await this.preDTE(selectDTE,selectPago);
                } else {
                    if (this.sigla=='NDV'){
                        await this.outDTE(selectDTE,selectPago);
                    } else {
                        this.Msg='Error de Contrato'
                        this.msgbox=true;
                        this.color='red';
                        this.showSnack();
                    }
                }
            }
            this.loading=false
        },
        async preDTE(selectDTE,selectPago){
            if(this.rut.trim()!=''){
                if(parseInt(this.docDTE)!=2){
                    await this.inDTE(selectDTE,selectPago);
                } else {
                    await this.NDE_Bsale(selectDTE,selectPago);
                }
            } else {
                this.Msg='Ingrese Cliente'
                this.msgbox=true;
                this.color='red';
                this.showSnack();
            }
        },
        async outDTE(selectDTE,selectPago){
            console.log(this.items);
            if (parseFloat(this.total)!=0){
                if (selectDTE!=0 && selectPago!=0){
                    this.loading=true;
                    this.btnGrabar=false;
                    this.OutID=0;
                    //obtener ID nuevo del dte
                    const params={
                        'contrato':this.contrato,
                        'orden':this.orden,
                        'estado':'V',
                        'usuario':this.usu
                    };
                    try {
                        const response = await axios.post(process.env.VUE_APP_URL + '/api/inv/DTE/id/new/v2/',params);
                        const res = response.data;
                        if (res=='si'){
                            const response1 = await axios.get(process.env.VUE_APP_URL + '/api/inv/DTE/id/new/v2/'+this.contrato+'/'+this.orden+'/'+this.usu);
                            const res1 = response1.data;
                            if (res1[0].existe=='si'){
                                this.OutID=parseFloat(res1[0].Folio); 
                            }                            
                        };
                        if (this.OutID!=0){
                            //console.log(this.OutID);
                            //confirmar que no existe en DTE
                            const response2 = await axios.get(process.env.VUE_APP_URL + '/api/inv/DTE/one/'+this.contrato+'/'+this.OutID);
                            const res2 = response2.data;
                            if (res2[0].existe=='no'){ 
                                this.html=process.env.VUE_APP_URL + '/api/inv/prt/dev/v5/'+this.contrato+'/'+this.OutID+'/'+this.entidad;
                                const paramsDTE={
                                    'contrato':this.contrato,
                                    'numero':this.OutID,
                                    'tipoDte':selectDTE,
                                    'tipoPago':selectPago,
                                    'neto':this.neto,
                                    'iva':this.iva,
                                    'total':this.total,
                                    'fecha':this.hoy,
                                    'vencimiento':this.hoy,
                                    'orden':this.ndev,
                                    'rutaPDF':this.html,
                                    'rutaXML':this.html,
                                    'usuario':this.usu,
                                    'sucursal':this.nSucursal,
                                    'oficina':this.office,
                                    'ted': '',
                                };     
                                await this.saveDTE(paramsDTE);
                            } else {
                                this.Msg='No Existen Folios'
                                this.msgbox=true;
                                this.color='red';
                                this.showSnack();
                            }
                        } else {
                            this.Msg='Folio No Asignado'
                            this.msgbox=true;
                            this.color='red';
                            this.showSnack();
                        }
                    } catch (error) {
                        console.log(error)
                    }
                } else {
                    this.Msg='Seleccione DTE y Pago'
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                }
            } else {
                this.Msg='Sin Productos'
                this.msgbox=true;
                this.color='red';
                this.showSnack();
            }
            this.loading=false;
        },
        async inDTE(selectDTE,selectPago){
            if(this.nSucursal!=0){
                if (this.items.length!=0 && parseFloat(this.total)!=0 && this.orden!=''){
                    if (selectDTE!=0 && selectPago!=0){
                        this.loading=true;
                        // obtenemos el token del contrato
                        let valToken='';
                        const resToken = await axios.get(process.env.VUE_APP_URL + '/api/inv/token/access/'+this.contrato);
                        const respuesta = resToken.data;
                        if (respuesta[0].existe=='si'){ 
                            valToken=respuesta[0].Token;
                            // fecha cotizacion formato Bsale
                            let intFecha=Date.parse(this.fecha);
                            let strFecha=intFecha.toString();
                            strFecha=strFecha.substring(0,10);
                            const numFecha=parseFloat(strFecha);
                            // fecha actual formato Bsale
                            let intHoy=Date.parse(this.hoy);
                            let strHoy=intHoy.toString();
                            strHoy=strHoy.substring(0,10);
                            const numHoy=parseFloat(strHoy);
                            //api bsale para rescatar id venta
                            let nID_Venta=0;
                            try {
                                let responseV;
                                // Factura
                                if(parseInt(this.docDTE)==5){ 
                                    responseV = await axios.get('https://api.bsale.cl/v1/documents.json?number='+this.orden+'&codesii=33', {headers : {"Accept":"application/json","content-type":"application/json","access_token":valToken}});
                                };
                                // Boleta 
                                if(parseInt(this.docDTE)==22){ 
                                    responseV = await axios.get('https://api.bsale.cl/v1/documents.json?number='+this.orden+'&codesii=39', {headers : {"Accept":"application/json","content-type":"application/json","access_token":valToken}});
                                };
                                const resVenta = responseV.data;
                                //console.log(resVenta);
                                if (resVenta.length!=0){
                                    nID_Venta=resVenta.items[0].id;
                                }
                            } catch (error) {
                                console.log(error);
                            };
                            //api bsale para rescatar id detalle de venta
                            let nID_Details=0;
                            let pDetalle=[];
                            try {
                                const responseD = await axios.get('https://api.bsale.cl/v1/documents/'+nID_Venta+'/details.json', {headers : {"Accept":"application/json","content-type":"application/json","access_token":valToken}});
                                const resDetails = responseD.data;
                                //console.log(resDetails);
                                if (resDetails.length!=0){
                                    //recorrer los items de la venta
                                    this.items.forEach(elementos => {
                                        // recorrer los detalles del documento
                                        resDetails.items.forEach(element => {
                                            // llena el details de Bsale
                                            if(element.variant.description==elementos.producto && parseFloat(elementos.cantidad)>0){
                                                pDetalle.push({
                                                    "documentDetailId": parseFloat(element.id),
                                                    "quantity": parseFloat(elementos.cantidad).toFixed(4),
                                                    //"unitValue": parseFloat(elementos.unidad).toFixed(4),
                                                    "unitValue":0,                            
                                                })        
                                                nID_Details=1;
                                            }                                
                                        });
                                    });
                                }                            
                            } catch (error) {
                                console.log(error);
                            };
                            if (nID_Venta!=0 && nID_Details!=0){
                                // creamos cliente devolucion Bsale
                                let pCliente;
                                if(this.ntipoDte!=22){ // factura
                                    pCliente={
                                        "code": this.rut,
                                        "city": this.ciudad,
                                        "company": this.razon,
                                        "municipality": this.comuna,
                                        "activity": this.giro,
                                        "address": this.direccion
                                    };
                                } else { // boleta
                                    pCliente={
                                        "code": this.dev_rut,
                                        "city": this.dev_ciudad,
                                        "municipality": this.dev_comuna,
                                        "address": this.dev_direccion,
                                        "firstName":this.dev_nombre,
                                        "lastName": this.dev_apellido
                                    }; 
                                };
                                // creamos parametros para generar devolucion
                                const emitDTE=
                                    {
                                        "documentTypeId": parseFloat(selectDTE),
                                        "officeId": parseInt(this.office),
                                        "emissionDate": numHoy,
                                        "expirationDate": numHoy,
                                        "referenceDocumentId": nID_Venta,
                                        "motive": "Devolucion de productos",
                                        "priceAdjustment": 0,
                                        "editTexts": 0,
                                        "type": 0,
                                        "client": pCliente,
                                        "details": pDetalle,
                                        "declareSii": 1
                                    }
                                // consumir api Bsale para crear DTE
                                let resDTE =[];
                                console.log('paramsDte', emitDTE);
                                try {
                                    const response = await axios.post('https://api.bsale.cl/v1/returns.json', emitDTE , {headers : {"Accept":"application/json","content-type":"application/json","access_token":valToken}});
                                    resDTE = response.data;
                                } catch (error) {
                                    console.log(error);                        
                                }
                                if (resDTE.length!=0){
                                    //console.log(resDTE);
                                    const NotaCredito=resDTE.credit_note.id;
                                    // consumir api para rescatar los datos de la NC
                                    let resNC =[];
                                    const responseNC = await axios.get('https://api.bsale.cl/v1/documents/'+NotaCredito+'.json', {headers : {"Accept":"application/json","content-type":"application/json","access_token":valToken}});
                                    resNC = responseNC.data;
                                    if (resNC.length!=0){
                                        this.envioDTE(this.envio,resNC.urlPdf,resNC.urlXml);
                                        this.html=resNC.urlPdf;
                                        this.btnPrt=true;
                                        this.btnGrabar=false;
                                        this.OutID=0;
                                        this.OutID=resNC.number;                      
                                        const paramsDTE={
                                            'contrato':this.contrato,
                                            'numero':resNC.number,
                                            'tipoDte':selectDTE,
                                            'tipoPago':selectPago,
                                            'neto':this.neto,
                                            'iva':this.iva,
                                            'total':this.total,
                                            'fecha':this.hoy,
                                            'vencimiento':this.hoy,
                                            'orden':this.ndev,
                                            'rutaPDF':resNC.urlPdf,
                                            'rutaXML':resNC.urlXml,
                                            'usuario':this.usu,
                                            'sucursal':this.nSucursal,
                                            'oficina':this.office,
                                        };
                                        //console.log(paramsDTE);
                                        await this.saveDTE(paramsDTE);                    
                                    } else {
                                        this.Msg='DTE enviado sin registro'
                                        this.msgbox=true;
                                        this.color='warning';
                                        this.showSnack();
                                    }
                                } else {
                                    this.Msg='DTE no enviado'
                                    this.msgbox=true;
                                    this.color='red';
                                    this.showSnack();
                                }
                            } else { 
                                this.Msg='Documento no Valido'
                                this.msgbox=true;
                                this.color='red';
                                this.showSnack(); 
                            }
                        } else { 
                            this.Msg='DTE No autorizado'
                            this.msgbox=true;
                            this.color='red';
                            this.showSnack();
                        }
                    } else {
                        this.Msg='Seleccione DTE y Pago'
                        this.msgbox=true;
                        this.color='red';
                        this.showSnack();
                    }
                    this.loading=false;
                } else {
                    this.Msg='Sin Datos para DTE'
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                }
            } else {
                this.Msg='Devolucion Sin Sucursal'
                this.msgbox=true;
                this.color='red';
                this.showSnack();
            }
        },
        async saveDTE(parametrosDTE){
            const response = await axios.post(process.env.VUE_APP_URL + '/api/inv/v2/DTE/nueva',parametrosDTE);
            const datos=response.data;
            if (datos=='si'){ 
                await this.saveDetalle();
                const ttdev=parseFloat(this.totaldev)+1;
                this.totaldev=ttdev.toString();
            } else {
                this.Msg='DTE enviado sin registro Local'
                this.msgbox=true;
                this.color='warning';
                this.showSnack();
            }
        },
        async saveDetalle(){
            let t=0;
            if (this.items.length!=0) {
                for (var i = 0; i < this.items.length; i++) {
                    var parametros2={
                        'contrato': this.contrato,
                        'orden': this.ndev,
                        'entidad': this.entidad,
                        'tipo': 'Neto',
                        'cv': 'D',
                        'sku':this.items[i].codigo,
                        'producto':this.items[i].producto,
                        'precio':this.items[i].precioitem,
                        'cantidad':this.items[i].cantidad,
                        'bodega': this.items[i].bodega,
                        'observa':'',
                        'usuario':this.usu,
                        'referencia':this.OutID};
                    const response2 = await axios.post(process.env.VUE_APP_URL + '/api/inv/compraventa/nueva',parametros2);
                    const datos2=response2.data;
                    //console.log(datos2);
                    if (datos2=='si'){ t++ }
                };
                if (t!=this.items.length) {
                    this.Msg='DTE enviado sin Detalle local';
                    this.msgbox=true;
                    this.color='warning';
                    this.showSnack();
                } else {
                    await this.UpdateStock();                    
                }
            }
        },
        async UpdateStock(){
            let t=0;
            if (this.items.length!=0) {
                for (var i = 0; i < this.items.length; i++) {
                    let mySigno = '0+';
                    let myOrigen ='Devolucion';
                    if(parseInt(this.docDTE)==2){ 
                        mySigno = '0-';
                        myOrigen = 'Ingreso';
                    };
                    var parametros1={
                        'contrato': this.contrato,
                        'sku': this.items[i].codigo,
                        'cantidad': this.items[i].cantidad,
                        'signo': mySigno,
                        'bodega': this.items[i].bodega,
                        'usuario': this.usu,
                        'observa': '',
                        'origen':myOrigen
                    };
                    const response1 = await axios.post(process.env.VUE_APP_URL + '/api/inv/stock',parametros1);
                    const datos1=response1.data;
                    if (datos1=='si'){ t++ }
                };
                if (t!=this.items.length) {
                    this.Msg='DTE enviado sin actualizar Stock';
                    this.msgbox=true;
                    this.color='warning';
                    this.showSnack();
                } else {
                    this.btnPrt=true;
                    this.Msg='DTE exitoso';
                    this.msgbox=true;
                    this.color='success';
                    this.showSnack();
                }
            }
        },
        async envioDTE(datoEnvio,datoPDF,datoXML){
            if (datoEnvio.trim()!=''){
                let InstFormData = new FormData();
                InstFormData.append('email' , datoEnvio);
                InstFormData.append('pdf' , datoPDF);
                InstFormData.append('xml' , datoXML);
                const response= await axios.post(process.env.VUE_APP_URL + '/api/server/sender', InstFormData , {headers : {'content-type': 'multipart/form-data'}});
                //console.log(response.data)
            }
        },
        onlyNumber ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57)) { // && keyCode !== 46 is dot
                $event.preventDefault();
            }
        },
        onlyDecimal ($event) {
         //console.log($event.keyCode); //keyCodes value
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // && keyCode !== 46 is dot
                $event.preventDefault();
            }
        },
        async save(line){
            console.log('save');
            if(this.editCantidad!=''){
                if(parseFloat(line.cantidaditem)>=parseFloat(this.editCantidad)){
                    line.cantidad = parseFloat(this.editCantidad);
                    line.tcantidad = parseFloat(this.editCantidad);
                    this.total = parseFloat(line.precioitem)*parseFloat(this.editCantidad);
                    await this.reCalcular(this.total);
                    this.editCantidad = '';
                } else {
                    this.Msg='Cantidad excede maximo para devolución';
                    this.msgbox=true;
                    this.color='error';
                    this.showSnack();
                }
            }
        },
        cancel() {
            console.log('cancel');
            this.editCantidad='';
        },
        open() {
            console.log('open');
            this.editCantidad='';
        },
        close() {
            console.log('close');
            this.editCantidad='';
        },
        async NDE_Bsale(selectDTE,selectPago){
            if(this.nSucursal!=0){
                if (this.items.length!=0 && parseFloat(this.total)!=0 && this.orden!=''){
                    if (selectDTE!=0 && selectPago!=0){
                        this.loading=true;
                        // obtenemos el token del contrato
                        let valToken='';
                        const resToken = await axios.get(process.env.VUE_APP_URL + '/api/inv/token/access/'+this.contrato);
                        const respuesta = resToken.data;
                        if (respuesta[0].existe=='si'){ 
                            valToken=respuesta[0].Token;
                            // fecha cotizacion formato Bsale
                            let intFecha=Date.parse(this.fecha);
                            let strFecha=intFecha.toString();
                            strFecha=strFecha.substring(0,10);
                            const numFecha=parseFloat(strFecha);
                            // fecha actual formato Bsale
                            let intHoy=Date.parse(this.hoy);
                            let strHoy=intHoy.toString();
                            strHoy=strHoy.substring(0,10);
                            const numHoy=parseFloat(strHoy);
                            //api bsale para rescatar id de la Nota de Credito
                            let nID_Venta=0;
                            const responseV = await axios.get('https://api.bsale.cl/v1/documents.json?limit=50&number='+this.orden+'&codesii=61', {headers : {"Accept":"application/json","content-type":"application/json","access_token":valToken}});
                            const resVenta = responseV.data;
                            //console.log('rescarar ID de la NCE', resVenta);
                            if (resVenta.length!=0){
                                nID_Venta=resVenta.items[0].id;
                                // creamos parametros para generar devolucion
                                const emitDTE={
                                    "documentTypeId": selectDTE,
                                    "officeId": 1,
                                    "emissionDate": numHoy,
                                    "expirationDate": numHoy,
                                    "referenceDocumentId": nID_Venta,
                                    "declareSii": 1
                                };
                                // consumir api Bsale para crear DTE
                                let resDTE =[];
                                const response = await axios.post('https://api.bsale.cl/v1/returns/' + nID_Venta + '/annulments.json', emitDTE, {headers : {"Accept":"application/json","content-type":"application/json","access_token":valToken}});
                                resDTE = response.data;
                                if (resDTE.length!=0){
                                    const NotaDebito=resDTE.debit_note.id;
                                    // consumir api para rescatar los datos de la ND
                                    let resND =[];
                                    const responseND = await axios.get('https://api.bsale.cl/v1/documents/'+NotaDebito+'.json', {headers : {"Accept":"application/json","content-type":"application/json","access_token":valToken}});
                                    resND = responseND.data;
                                    if (resND.length!=0){
                                        this.envioDTE(this.envio,resND.urlPdf,resND.urlXml);
                                        this.html=resND.urlPdf;
                                        this.btnPrt=true;
                                        this.btnGrabar=false;
                                        this.OutID=0;
                                        this.OutID=resND.number;                      
                                        const paramsDTE={
                                            'contrato':this.contrato,
                                            'numero':resND.number,
                                            'tipoDte':selectDTE,
                                            'tipoPago':selectPago,
                                            'neto':this.neto,
                                            'iva':this.iva,
                                            'total':this.total,
                                            'fecha':this.hoy,
                                            'vencimiento':this.hoy,
                                            'orden':this.ndev,
                                            'rutaPDF':resND.urlPdf,
                                            'rutaXML':resND.urlXml,
                                            'usuario':this.usu,
                                            'sucursal':this.nSucursal,
                                            'oficina':this.office,
                                        };
                                        //console.log(paramsDTE);
                                        await this.saveDTE(paramsDTE);
                                    } else {
                                        this.Msg='DTE enviado sin registro'
                                        this.msgbox=true;
                                        this.color='warning';
                                        this.showSnack();
                                    }
                                } else {
                                    this.Msg='DTE no enviado'
                                    this.msgbox=true;
                                    this.color='red';
                                    this.showSnack();
                                }
                            } else {
                                this.Msg='Documento no Valido'
                                this.msgbox=true;
                                this.color='red';
                                this.showSnack(); 
                            }
                        } else {
                            this.Msg='DTE No autorizado'
                            this.msgbox=true;
                            this.color='red';
                            this.showSnack();
                        } 
                    } else {
                        this.Msg='Seleccione DTE y Pago'
                        this.msgbox=true;
                        this.color='red';
                        this.showSnack();
                    }
                    this.loading=false;
                } else {
                    this.Msg='Sin Datos para DTE'
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                }
            } else {
                this.Msg='Devolucion Sin Sucursal'
                this.msgbox=true;
                this.color='red';
                this.showSnack();
            }
        },

        fechaNacional(fec){
            const dia = fec.substring(8,10);
            const mes = fec.substring(5,7);
            const anio = fec.substring(0,4);
            const hoy = dia + '-' + mes + '-' + anio;
            return hoy;
        },
        async search_emisor(){
            let result = [];
            try {
                //const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/search/emisor/dte/'+this.contrato);
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/emisor/'+this.contrato);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    result = datos;
                    // datos.forEach(element => {
                    //     if(parseInt(element.Oficina) == parseInt(this.office)){
                    //         result = element;
                    //     }
                    // })                    
                }
            } catch (error) {
                console.log(error)
            };
            return result
        },
        async imprimirPDF(){
            if (this.OutID!=0){
                try {
                    let myEmisor;
                    let myCliente;
                    let myDetalle=[];
                    let myTotales;
                    let myReferencia;
                    let myFechas;
                    let myDocumento;
                    //emisor = datos de la sucursal del usuario actual
                    const data_emisor = await this.search_emisor();
                    if(data_emisor.length!=0){
                        myEmisor = data_emisor[0];
                    };
                    //cliente
                    if(this.rutExpress!='1-9'){
                        myCliente = {
                            "rut": this.rut,
                            "razon": this.razon,
                            "giro": this.giro,
                            "direccion": this.direccion,
                            "comuna": this.comuna,
                            "ciudad": this.ciudad,
                            "telefono" : '',
                            "email" : this.email
                        }
                    } else {
                        myCliente = {
                            "rut": this.rut,
                            "razon": this.razon,
                            "giro": '',
                            "direccion": '',
                            "comuna": '',
                            "ciudad": '',
                            "telefono" : '',
                            "email" : ''
                        }
                    };
                    //detalle
                    console.log('items', this.items);
                    this.items.forEach(element => {
                        if(parseFloat(element.cantidad)!=0){
                            myDetalle.push({
                                "sku": element.codigo,
                                "producto": element.producto,
                                "precio": element.precioitem,
                                "cantidad": element.cantidad
                            })                        
                        }
                    });
                    //totales
                    myTotales = {
                        "neto": this.neto,
                        "impuesto": this.impuesto,
                        "iva": this.iva,
                        "total": this.total,
                    };
                    //referencias
                    myReferencia = {
                        "folio": '',
                        "fecha": '',
                        "tipo": '',
                        "razon": ''
                    };
                    //fechas
                    myFechas = {
                        "emision": this.fechaNacional(this.hoy),
                        "vencimiento": this.fechaNacional(this.hoy),
                    };
                    //documento
                    const documento='DEVOLUCIÓN VENTA';
                    myDocumento = {
                        "folio": this.OutID,
                        "documento": documento,
                        "ted": '',
                        "sucursal": ''
                    };
                    //verPDF
                    const array_PDF = {
                        "myEmisor" : myEmisor,
                        "myCliente" : myCliente,
                        "myDetalle" : myDetalle,
                        "myTotales" : myTotales,
                        "myReferencia" : myReferencia,
                        "myFechas" : myFechas,
                        "myDocumento" : myDocumento,
                    };
                    console.log('parametros PDF', array_PDF)
                    await this.verPDF(array_PDF);
                } catch (error) {
                    console.log(error)
                }
            }
        },        
        async verPDF(array_PDF){
            let myEmisor = array_PDF.myEmisor;
            let myCliente = array_PDF.myCliente;
            let myDetalle = array_PDF.myDetalle;
            let myTotales = array_PDF.myTotales;
            let myReferencia = array_PDF.myReferencia;
            let myFechas = array_PDF.myFechas;
            let myDocumento = array_PDF.myDocumento;
            const total_items = myDetalle.length;
            let base = 112
            const ancho = 72;
            const largo = (parseInt(total_items) * 4) + parseInt(base);
            const hoja = [ancho,largo];
            const doc = new jsPDF('p', 'mm', hoja);
            //const image = fs.readFileSync('Clientes/TerraFirma/logoTerra.jpg');
            //doc.addImage(image, 'JPEG', 2, 7, 45, 20);
            //doc.setDrawColor(255,0,0);
            //grosor linea
            doc.setLineWidth(0.5);
            //horizontal lines
            doc.line(22, 5, 67, 5);
            doc.line(22, 25, 67, 25);
            //vertical lines
            doc.line(22, 5, 22, 25);
            doc.line(67, 5, 67, 25);

            //tipo de letra bold = negrita y normal = normal
            doc.setFont("Helvetica", "bold");
            //tamaño de letra
            doc.setFontSize(10);
            //doc.setTextColor(255,0,0);
            //formateo de rut emisor
            var tmp 	= myEmisor.Rut.split('-');
		    var digv	= tmp[1]; 
		    var ruti 	= tmp[0];
            const format_rut = new Intl.NumberFormat("de-DE").format(ruti);
            const rut_emisor = ''+format_rut+'-'+digv;
            doc.text('R.U.T. : ' + (''+rut_emisor).toUpperCase(), 44.5, 10, { align: "center" });
            doc.text(myDocumento.documento, 44.5, 15, { align: "center" });
            doc.text('N° ' + myDocumento.folio, 44.5, 20, { align: "center" });
            
            doc.setLineWidth(0.2);
            doc.line(2, 32, 70, 32);

            //datos emisor
            doc.setFont("Helvetica", "bold");
            doc.setFontSize(9);

            const anchoRazon = 70;
            let space_line = 3;
            let line = 37;
            let suma_line = 0;
            
            const razon_emisor = myEmisor.Razon_Social;
            const parrafo_razon = doc.splitTextToSize((''+razon_emisor).toUpperCase(), anchoRazon);
            doc.text(parrafo_razon, 36, line, {align: 'center',lineHeightFactor: 1,maxWidth:60});
            
            //sumar las lineas del parrafo
            suma_line = parseInt(parrafo_razon.length) * space_line;
            line = line + suma_line + space_line;

            const anchoEmisor = 60;
            space_line = 2

            doc.setFont("Helvetica", "normal");
            doc.setFontSize(7);

            doc.text('GIRO: ', 2, line);
            const giro_emisor = myEmisor.Giro;
            const parrafo_giro = doc.splitTextToSize((''+giro_emisor).toUpperCase(), anchoEmisor);
            doc.text(parrafo_giro, 17, line, {align: 'left',lineHeightFactor: 1,maxWidth:60});
            
            //sumar las lineas del parrafo
            suma_line = parseInt(parrafo_giro.length) * space_line;
            line = line + suma_line + space_line;

            doc.text('DIRECCIÓN: ', 2, line);
            const direccion_emisor = myEmisor.Direccion;
            const parrafo_direccion = doc.splitTextToSize((''+direccion_emisor).toUpperCase(), anchoEmisor);
            doc.text(parrafo_direccion, 17, line, {align: 'left',lineHeightFactor: 1,maxWidth:60});
            
            //sumar las lineas del parrafo
            suma_line = parseInt(parrafo_direccion.length) * space_line;
            line = line + suma_line + space_line;

            // doc.text('COMUNA: ', 2, line);
            // const comuna_emisor = myEmisor.Comuna;
            // doc.text((''+comuna_emisor).toUpperCase(), 17, line);

            doc.text('CIUDAD: ', 2, line);
            const ciudad_emisor = myEmisor.Ciudad
            doc.text((''+ciudad_emisor).toUpperCase(), 17, line);

            //sumar las lineas del parrafo
            suma_line = 2
            line = line + suma_line + space_line;
            
            doc.text('SUCURSAL: ', 2, line);
            const sucursal_emisor = myDocumento.sucursal;
            const parrafo_sucursal = doc.splitTextToSize((''+sucursal_emisor).toUpperCase(), anchoEmisor);
            doc.text(parrafo_sucursal, 17, line, {align: 'left',lineHeightFactor: 1,maxWidth:60});
            
            //sumar las lineas del parrafo
            suma_line = 0;
            line = line + suma_line + space_line;

            doc.setLineWidth(0.2);
            doc.line(2, line, 70, line);

            line = line + 4;

            //datos cliente

            doc.text('CLIENTE: ', 2, line);
            const razon_cliente = myCliente.razon;
            const parrafo_cliente = doc.splitTextToSize((''+razon_cliente).toUpperCase(), anchoEmisor);
            doc.text(parrafo_cliente, 17, line, {align: 'left',lineHeightFactor: 1,maxWidth:60});
            
            //sumar las lineas del parrafo
            suma_line = parseInt(parrafo_cliente.length) * space_line;
            line = line + suma_line + space_line;

            doc.text('RUT: ', 2, line);
            const rut_cliente = myCliente.rut;
            const parrafo_rut = doc.splitTextToSize((''+rut_cliente).toUpperCase(), anchoEmisor);
            doc.text(parrafo_rut, 17, line, {align: 'left',lineHeightFactor: 1,maxWidth:60});
            
            //sumar las lineas del parrafo
            suma_line = parseInt(parrafo_rut.length) * space_line;
            line = line + suma_line + space_line;

            doc.text('GIRO: ', 2, line);
            const giro_cliente = myCliente.giro;
            const parrafo_giro_cliente = doc.splitTextToSize((''+giro_cliente).toUpperCase(), anchoEmisor);
            doc.text(parrafo_giro_cliente, 17, line, {align: 'left',lineHeightFactor: 1,maxWidth:60});
            
            //sumar las lineas del parrafo
            suma_line = parseInt(parrafo_giro_cliente.length) * space_line;
            line = line + suma_line + space_line;

            doc.text('DIRECCIÓN: ', 2, line);
            const direccion_cliente = myCliente.direccion;
            const comuna_cliente = myCliente.comuna;
            const ciudad_cliente = myCliente.ciudad;
            const direccion_compuesta_cliente = direccion_cliente + ', ' + comuna_cliente + ', ' + ciudad_cliente;
            const parrafo_direccion_cliente = doc.splitTextToSize((''+direccion_compuesta_cliente).toUpperCase(), anchoEmisor);
            doc.text(parrafo_direccion_cliente, 17, line, {align: 'left',lineHeightFactor: 1,maxWidth:60});
            
            //sumar las lineas del parrafo
            suma_line = parseInt(parrafo_direccion_cliente.length) * space_line;
            line = line + suma_line + space_line;
 
            doc.text('FECHA EMISION: ', 2, line);
            const emision_cliente = myFechas.emision;
            doc.text(emision_cliente, 23, line);

            doc.text('FECHA VCTO.: ', 39, line);
            const vence_cliente = myFechas.vencimiento;
            doc.text(vence_cliente, 57, line);

            suma_line = 0;
            line = line + suma_line + space_line;

            // doc.text('FORMA DE PAGO: ', 2, line);
            // const pago_cliente = myPago[0].forma;
            // doc.text((''+pago_cliente).toUpperCase(), 21, line);

            // suma_line = 0;
            // line = line + suma_line + space_line;

            doc.line(2, line, 70, line);

            //detalle
            doc.setFontSize(7);
            //encabezado
            line = line + 2.5;
            doc.text('DESCRIPCION PRODUCTO', 2, line);
            line = line + 2.5;
            doc.text('CANT. X PRECIO', 2, line);
            doc.text('TOTAL', 60, line);
            line = line + 1;
            doc.line(2, line, 70, line);
            line = line + 1;
            myDetalle.forEach(element => {
                line = line + 2;
                doc.text((''+element.producto).toUpperCase(), 2, line);
                line = line + 2.5;
                const format_valor = new Intl.NumberFormat("de-DE").format(parseFloat(element.precio));
                const format_cantidad = new Intl.NumberFormat("de-DE").format(parseFloat(element.cantidad));
                const precio_item = parseFloat(element.precio) * parseFloat(element.cantidad);
                const format_precio =new Intl.NumberFormat("de-DE").format(parseFloat(precio_item));
                doc.text((''+format_cantidad+' x $'+format_valor).toUpperCase(), 2, line);
                doc.text(('$'+format_precio).toUpperCase(), 70, line, {align: 'right'});
            });
            line = line + 1;
            doc.line(2, line, 70, line);
            //referencias
            if(parseInt(this.ntipoDte)==5){ // factura
                line = line + 2;
                doc.text('Referencia a otros documentos.', 2, line);
                line = line + 3;
                doc.text('TIPO DOCTO.', 2, line);
                doc.text('FOLIO.', 30, line);
                doc.text('FECHA', 50, line);
                line = line + 2;
                doc.text(myReferencia.tipo, 2, line);
                doc.text(myReferencia.folio, 30, line);
                doc.text(myReferencia.fecha, 50, line);
                line = line + 1;
                doc.line(2, line, 70, line);
            }; 
            //totales
            doc.setFont("Helvetica", "bold");
            doc.setFontSize(8);
            line = line + 5;
            doc.text('MONTO NETO', 32, line);
            const format_neto = new Intl.NumberFormat("de-DE").format(parseFloat(myTotales.neto).toFixed(2));
            doc.text(format_neto, 70, line, {align: 'right'});
            line = line + 3;
            doc.text('IVA ('+myTotales.impuesto+'%)', 32, line);
            const format_iva = new Intl.NumberFormat("de-DE").format(parseFloat(myTotales.iva).toFixed(2));
            doc.text(format_iva, 70, line, {align: 'right'});
            line = line + 3;
            doc.text('TOTAL', 32, line);
            const format_total = new Intl.NumberFormat("de-DE").format(parseFloat(myTotales.total).toFixed(0));
            doc.text(format_total, 70, line, {align: 'right'});

            line = line + 10;
            doc.text('Este Documento no es valido como DTE' , 36, line, { align: "center" });

            doc.output('dataurlnewwindow');

        },

    }
}
</script>